import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import Config from 'arbitrip-common/client/utils/Config';

import DealActions from '../../../../actions/DealActions';
import LazyRecheckActions from '../../../../actions/LazyRecheckActions';
import RouterWrapper from '../../../../utils/RouterWrapper';
import { isAnonymousBlocked, redirectToLogin } from '../../../../utils/App';

const PERMISSION_PERFORM_RESERVATION = 'perform_reservation';

/**
 * The hotel page's Book flow, as `DealComponent.react.js` `handleOnBookClick` runs it, minus the
 * analytics call: the lazy-recheck branch, the dev-mode `reservation_manipulation` attach,
 * `DealActions.chooseDeal`, then `RouterWrapper.goToReservationPage`.
 */
export default function useBookDeal({ hotel, profile, reservationManipulation }) {
    const navigate = useNavigate();

    return useCallback(
        (deal) => {
            if (deal && deal.is_lazy_recheck === true) {
                if (isAnonymousBlocked(profile, PERMISSION_PERFORM_RESERVATION)) {
                    redirectToLogin(profile);
                    return;
                }
                LazyRecheckActions.start(deal, hotel && hotel.id);
                return;
            }

            if (Config.dev_mode || profile?.is_arbi_tester) {
                deal.reservation_manipulation = reservationManipulation;
            }

            DealActions.chooseDeal(deal);
            RouterWrapper.goToReservationPage(navigate);
        },
        [navigate, hotel, profile, reservationManipulation],
    );
}
